import React from 'react';
import { CloseButton, ModalContainer, Overlay } from './modal.styles';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  fitContent?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, fitContent }) => {
  if (!isOpen) return null;

  const handleContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Overlay isOpen={isOpen}>
      <ModalContainer fitContent={fitContent} isOpen={isOpen} onClick={handleContainerClick}>
        <CloseButton onClick={onClose} aria-label="Close modal">
          &times;
        </CloseButton>
        {children}
      </ModalContainer>
    </Overlay>
  );
};

export default Modal;
